<template>
  <div class="page-content movie-ticket-master">
    <h1 class="page-title">{{ $locale("sideMenu.film.moviTicketMaster") }}</h1>
    <CommonTicketTable :authority="authority" ref="CommonTicketTable" />
  </div>
</template>

<script>
import CommonTicketTable from "@/components/Movie/CommonTicketTable";
import  { moviTicketAuthority, listApiTypeMapping } from "@/assets/js/movieStatic";
import { mapState, mapActions } from "vuex";

import { getMoviTicketListService } from "@/helpers/service/api/movie.js";
import { getClientListService } from "@/helpers/service/api/common";
import { adminTypeList } from "@/utils/common";

export default {
  name: "movie-ticket-master",
  data() {
    return {
      apiType: "global",
      mvtkList: [],
    };
  },
  created() {
    if (this.clientList.length === 0) {
      getClientListService({
        page: 0,
        pageSize: 9999,
        field: ["id", "name"],
      }).then(res => {
        this.setClientList(res.data.data);
      });
    }
    getMoviTicketListService({
      ...(this.brandId && this.adminType === adminTypeList.BRAND ? { brandId: this.brandId } : {}),
      ...(this.cinemaId && this.adminType === adminTypeList.CINEMA ? { cinemaId: this.cinemaId } : {}),
      type: listApiTypeMapping[this._adminType],
      page: 0,
      pageSize: 10
    }).then(res => {
      let _tableData = res.data.data;
      this.$refs["CommonTicketTable"].tableData = _tableData;
      this.$refs["CommonTicketTable"].pageCount = res.data.count;
    });
  },
  provide() {
    return {
      apiTypeForChildren: this.apiType,
      getApiType: () => this.apiType,
      clientList: () => this.clientList
    };
  },
  methods: {
    ...mapActions("api", [ "setClientList" ]),
  },
  computed: {
    ...mapState("app", {
      _adminType: state => state.adminType,
      cinemaId: state => state.cinemaId,
      brandId: state => state.brandId,
    }),
    ...mapState("api", {
      clientList: state => state.clientList
    }),
    adminType() {
      return this._adminType ? this._adminType : localStorage.get("adminType");
    },
    authority() {
      return moviTicketAuthority[this.adminType];
    },
  },
  components: {
    CommonTicketTable,
  }
};
</script>
